const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    sl: 1000,
    lg: 1280,
    xl: 1440,
  },
};

export default breakpoints;
